import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import Tag from '../../models/Tag';

async function getTags(
  idDomain?: string | null,
  idSubscription?: string | null
): Promise<Tag[]> {
  try {
    const params = new URLSearchParams();
    if (idDomain) params.append('id_domain', idDomain);
    if (idSubscription) params.append('id_subscription', idSubscription);
    const query = params.toString() ? `?${params.toString()}` : '';

    const response = await HttpClient.get(`/tags${query}`);
    return (response.data.tags as Record<string, unknown>[]).map((t) => Tag.fromApi(t));
  } catch (e) {
    console.log('error: ', e);
    throw new GetTagsFailure();
  }
}

export class GetTagsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getTags;
